import React from 'react';

const defaultProps = {};
const noopComponent = () => null;

export default function getExternalComponent(componentName, props = defaultProps) {
    let ExternalComponent = noopComponent;
    try {
        /* istanbul ignore next */
        if (!__SERVER__ && window && window.$yoda) {
            ExternalComponent = window.$yoda.default.getComponent(componentName);
        } else if (global && global.$yoda) {
            ExternalComponent = global.$yoda.$yoda.default.getComponent(componentName);
        }
    } catch (e) {
        /* istanbul ignore next */
        console.warn(`[EXTERNAL] : [${componentName}]could not be loaded`);
    }

    /* istanbul ignore next */
    return <ExternalComponent {...(props || defaultProps)} />;
}
